import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { createSlice } from "@reduxjs/toolkit";

const getInitialState = () => ({
  connected_users: [],
  onlineUsers: [],
  all_users: [],
  selectedUser: null,
  socketConnection: false
});

const initialState = getInitialState();

const persistConfig = {
  key: "users",
  storage,
  whitelist: ["connected_users", "onlineUsers", "all_users"], // place to select which state you want to persist
};

const findUserIndex = (users, id) => users.findIndex((user) => Number(user.id) === Number(id));

const userSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    setConnectedUsers: (state, action) => {
      state.connected_users = action.payload || [];
    },
    selectUserById: (state, action) => {
      const userIndex = findUserIndex(state.connected_users, action.payload);
      state.selectedUser = userIndex === -1 ? null : state.connected_users[userIndex];
    },
    setSelectedUser: (state, action) => {
      state.selectedUser = action.payload;
    },
    setAllUsers: (state, action) => {
      state.all_users = action.payload || [];
    },
    updateConnectedUser: (state, action) => {
      const user = action.payload;
      const userIndex = findUserIndex(state.connected_users, user?.id);

      if (userIndex !== -1) {
        state.connected_users[userIndex] = user;
      }

      state.selectedUser = user;
    },
    addConnectedUser: (state, action) => {
      const user = action.payload;
      const userIndex = findUserIndex(state.connected_users, user?.id);

      if (userIndex === -1) {
        state.connected_users.push(user);
      } else {
        state.connected_users[userIndex] = user;
      }
    },
    deleteConnectedUser: (state, action) => {
      const userIndex = findUserIndex(state.connected_users, action.payload);

      if (userIndex !== -1) {
        state.connected_users.splice(userIndex, 1);
      }
    },
    setOnlineUsers: (state, action) => {
      state.onlineUsers = action.payload || [];
    },
    clearUser: () => getInitialState(),
    setSocketConnection: (state, action) => {
      state.socketConnection = action.payload;
    },
  },
});

export const {
  setConnectedUsers,
  selectUserById,
  setSelectedUser,
  setAllUsers,
  updateConnectedUser,
  addConnectedUser,
  deleteConnectedUser,
  setOnlineUsers,
  clearUser,
  setSocketConnection,
} = userSlice.actions;

export default persistReducer(persistConfig, userSlice.reducer);
